import { ifAll, IGetValueArgs, not } from "@components/smart/FieldInfo";
import BindingContext from "@odata/BindingContext";
import {
    DocumentEntity,
    DocumentVatClassificationSelectionEntity,
    EntityTypeName,
    ICountryEntity,
    IVatClassificationEntity,
    VatClassificationEntity
} from "@odata/GeneratedEntityTypes";
import { CountryClassificationCode, CountryCode } from "@odata/GeneratedEnums";

export const SAVED_VATS_PATH = "##SavedVats##";
export const ITEMS_VAT_DEDUCTION_PATH = "##ItemsVatDeduction##";
export const VAT_REVERSE_CHARGE_SELECT_PATH = "##VatReverseChargeSelect##";
export const VAT_CLASSIFICATION_PATH = `${DocumentEntity.VatClassificationSelection}/${DocumentVatClassificationSelectionEntity.VatClassification}`;
export const AUTOMATED_VAT_INCLUSION_MODE_PATH = `${VAT_CLASSIFICATION_PATH}/${VatClassificationEntity.IsInAutomatedVatInclusionMode}`;
export const DOCUMENT_REVERSE_CHARGE_PATH = `${VAT_CLASSIFICATION_PATH}/${VatClassificationEntity.VatReverseCharge}`;
export const ORIGINAL_CLEARED_AMOUNT_PATH = "##OriginalClearedAmount##";
export const BaseConditionsPlaceholderPath = BindingContext.localContext("BaseConditionsPlaceholder");

function getCountry({ storage, data }: IGetValueArgs): ICountryEntity {
    const entity = data ?? storage.data.entity;
    return entity.BusinessPartner?.Country ?? entity.Country ?? {
        Code: CountryCode.CzechRepublic,
        IsEuMember: true,
        IsEEA: true
    };
}

export function isAgendaDomesticRule(args: IGetValueArgs): boolean {
    const entity = args.data ?? args.storage.data.entity;
    if (args.storage?.data?.bindingContext.getEntityType().getName() === EntityTypeName.VatClassification) {
        return (entity as IVatClassificationEntity).CountryClassificationCode === CountryClassificationCode.Domestic;
    }
    return getCountry(args)?.Code === CountryCode.CzechRepublic;
}

export function isEeaRule(args: IGetValueArgs): boolean {
    const { entity, bindingContext } = args.storage.data;
    if (bindingContext.getEntityType().getName() === EntityTypeName.VatClassification) {
        return (entity as IVatClassificationEntity).CountryClassificationCode === CountryClassificationCode.EuropeanUnion;
    }
    return getCountry(args)?.IsEEA !== false;
}

export function isEuRule(args: IGetValueArgs): boolean {
    const { entity, bindingContext } = args.storage.data;
    if (bindingContext.getEntityType().getName() === EntityTypeName.VatClassification) {
        return (entity as IVatClassificationEntity).CountryClassificationCode === CountryClassificationCode.EuropeanUnion;
    }
    return getCountry(args)?.IsEuMember !== false;
}

// countries outside EEA region
export function isThirdWorldsRule(args: IGetValueArgs): boolean {
    return !isEeaRule(args);
}

export const isEeaRuleExceptAgendaDomestic = ifAll(isEeaRule, not(isAgendaDomesticRule)); // todo how to check correct format with TLocalContext
export const isEuRuleExceptAgendaDomestic = ifAll(isEuRule, not(isAgendaDomesticRule));